import Backbone from "backbone";
import $ from "jquery";
import SharedDispatcher from "../../../../Assets/javascripts/common/others/SharedDispatcher";

export default Backbone.View.extend({
  initialize: function () {

  },

  events: {
    "click .js-TabbedListAnchor-show": "show"
  },

  show: function (e) {
    const index = $(e.currentTarget).attr("data-id");
    SharedDispatcher.trigger("tabbedlist:show", { index })
  }
})
